module.exports = __webpack_public_path__ + "assets/img/btn-play.7ee22a58.png";